import { IconLlmMicrophone, IconLlmSend, IconLlmStop, IconLlmVolume, IconLlmVolumeX, IconWebsolute } from '@websolutespa/bom-mixer-icons';
import { useRef } from 'react';
import { useLlm } from '../../../useLlm/useLlm';
import { useLlmView } from '../../../useLlm/useLlmView';
import useAutosizeTextArea from '../../hooks/useAutosizeTextArea';
import { Blob } from '../Trigger/blob';
import { Suggestions } from './suggestions';

export const Prompt = () => {
  const textArea = useRef<HTMLTextAreaElement>(null);
  const prompt = useLlm(state => state.prompt);
  const messages = useLlm(state => state.messages);
  const streaming = useLlm(state => state.streaming);
  const speakEnabled = useLlm(state => state.speakEnabled);
  const { setPrompt, recognizeStart, recognizeStop, abort, toggleSpeak, hasSpeechSupport } = useLlm(state => state.actions);
  const { send } = useLlmView(state => state.actions);

  useAutosizeTextArea(textArea.current, prompt);

  const onChange = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
    const prompt = event.target?.value;
    setPrompt(prompt);
  };

  const onSubmit = async (event?: React.FormEvent) => {
    event && event.preventDefault();
    if (!prompt) {
      return;
    }
    await send(prompt, (response) => {
      // console.log('Prompt.onChunk', response.chunks);
    }, (response) => {
      // console.log('Prompt.onEnd', response);
    });
  };

  const onKeyDown = (event: React.KeyboardEvent) => {
    if (event.code == 'Enter' && !event.shiftKey) {
      onSubmit(event);
    }
  };

  return (
    <div className="llm__prompt">
      <div className="llm-container">
        {messages.length === 0 && (
          <div className="llm__prompt-suggestions">
            <Suggestions />
          </div>
        )}
        <form className="llm__prompt-form" onSubmit={onSubmit}>
          <div className="llm__prompt-input">
            {hasSpeechSupport() && (
              <button className="llm__prompt-speak" type="button" onClick={toggleSpeak}>
                {speakEnabled ? <IconLlmVolume /> : <IconLlmVolumeX />}
              </button>
            )}
            <textarea className="llm__prompt-textarea" name="prompt" onKeyDown={onKeyDown} onChange={onChange} ref={textArea} rows={1} value={prompt}></textarea>
            {hasSpeechSupport() && (
              <button className="llm__prompt-microphone" type="button"
                onMouseDown={() => recognizeStart()}
                onMouseUp={() => recognizeStop()}
                onTouchStart={() => recognizeStart()}
                onTouchEnd={() => recognizeStop()}
              >
                <IconLlmMicrophone />
              </button>
            )}
          </div>
          {streaming ?
            <button className="llm__prompt-stop" type="button" onClick={abort}>
              <Blob />
              <i><IconLlmStop /></i>
            </button>
            : <button className="llm__prompt-submit" type="submit" disabled={!prompt}>
              <Blob />
              <i><IconLlmSend /></i>
            </button>}
        </form>
        <a className="llm__prompt-powered-by" href="https://www.websolute.com/" target="_blank" title="Powered by Websolute">
          <span>powered by</span> <IconWebsolute />
        </a>
      </div>
    </div>
  );
};
